import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { PatientProfile } from "@/core/types";

import { patientProfileKeys } from "../keyFactory";
import { updatePatientProfile } from "../queryFunctions/updatePatientProfile";
import type { UpdatePatientProfileVariables } from "../queryFunctions/updatePatientProfile";

export function useUpdatePatientProfile({
  onSuccess,
  ...options
}: UseMutationOptions<PatientProfile, unknown, UpdatePatientProfileVariables> = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePatientProfile,
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: patientProfileKeys.details() });
      onSuccess?.(data, variables, context);
    },
  });
}
